import axios from '../../axios';

export default async function finishQuizRequest(): Promise<void> {
  const response = await axios.post<void>(
    `${process.env.REACT_APP_BASE_URL}/quiz/active/finish`
  );
  return response.data;
}
